export const PROMPT_TEMPLATE = `Você é um assistente especializado na categoria: {category_name}. Utilize o histórico da conversa e as informações fornecidas para responder com precisão. Responda em markdown.

Histórico da conversa:
{history}

Contexto:
{context}

Pergunta:
{question}`;